import React from "react";
import {
    FaBuilding,
    FaChartLine,
    FaCoins,
    FaHandshake,
    FaLandmark,
    FaMicrochip,
    FaNetworkWired,
    FaUserTie,
} from "react-icons/fa";

import banksFinanceImage from "../../../assets/audience-cards/banks-finance.png";
import brokerageAgentsImage from "../../../assets/audience-cards/brokerage-agents.png";
import buildersDevelopersImage from "../../../assets/audience-cards/builders-developers.png";
import investorsHnwisImage from "../../../assets/audience-cards/investors-hnwis.png";
import technologyProptechImage from "../../../assets/audience-cards/technology-proptech.png";

import "./who_its_built_for.css";

const audienceCards = [
    {
        icon: FaBuilding,
        bgIcon: FaBuilding,
        image: buildersDevelopersImage,
        title: "Builders & Developers",
        eyebrow: "Scale projects with the right network.",
        points: [
            "Access to investors and capital partners",
            "Strategic collaborations for project growth",
            "Exposure through curated industry platforms",
            "Integration of PropTech for sales and operations",
        ],
    },
    {
        icon: FaChartLine,
        bgIcon: FaCoins,
        image: investorsHnwisImage,
        title: "Investors & HNWIs",
        eyebrow: "Invest with structure, not noise.",
        points: [
            "Access to vetted real estate opportunities",
            "Direct interaction with developers and stakeholders",
            "Early insights into high-potential projects",
            "Participation in private investment discussions",
        ],
    },
    {
        icon: FaLandmark,
        bgIcon: FaLandmark,
        image: banksFinanceImage,
        title: "Banks & Financial Institutions",
        eyebrow: "Position at the centre of real estate growth.",
        points: [
            "Direct access to developers and active projects",
            "Opportunities to structure financing and mortgage solutions",
            "Visibility within a curated industry network",
            "Participation in discussions shaping real estate finance",
        ],
    },
    {
        icon: FaMicrochip,
        bgIcon: FaNetworkWired,
        image: technologyProptechImage,
        title: "Technology & PropTech",
        eyebrow: "Bring innovation into real estate.",
        points: [
            "Direct access to real estate stakeholders",
            "Opportunities to deploy and test solutions",
            "Strategic partnerships with developers and brokers",
            "Positioning within the PropTech ecosystem",
        ],
    },
    {
        icon: FaHandshake,
        bgIcon: FaUserTie,
        image: brokerageAgentsImage,
        title: "Brokerage Leaders & Agents",
        eyebrow: "Move from transactions to systems.",
        points: [
            "Access to developer inventory and opportunities",
            "Collaboration with structured networks",
            "Insights into modern sales and marketing systems",
            "Positioning within a professional ecosystem",
        ],
    },
];

const WhoItsBuiltFor = () => {
    return (
        <section id="who_built_for_section">
            <div id="who_built_for_intro">
                <h2 id="who_built_for_hdng">Who It&apos;s Built For</h2>
                <p id="who_built_for_subhdng">
                    Each member category is aligned with clear value and purpose within the ecosystem.
                </p>
            </div>

            <div id="who_built_for_grid">
                {audienceCards.map((card) => {
                    const Icon = card.icon;
                    const BgIcon = card.bgIcon;

                    return (
                        <article className="who_built_for_card" key={card.title}>
                            <div className="who_built_for_card_inner">
                                <div className="who_built_for_card_face who_built_for_card_front">
                                    <img
                                        className="who_built_for_card_image"
                                        src={card.image}
                                        alt=""
                                        loading="lazy"
                                    />
                                    <div className="who_built_for_card_front_content">
                                        <span className="who_built_for_card_icon" aria-hidden="true">
                                            <Icon />
                                        </span>
                                        <h3 className="who_built_for_card_title">{card.title}</h3>
                                    </div>
                                </div>

                                <div className="who_built_for_card_face who_built_for_card_back">
                                    <span className="who_built_for_card_bg_icon who_built_for_card_bg_icon_back" aria-hidden="true">
                                        <BgIcon />
                                    </span>
                                    <p className="who_built_for_card_eyebrow">{card.eyebrow}</p>
                                    <ul className="who_built_for_card_points">
                                        {card.points.map((point) => (
                                            <li key={point}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
};

export default WhoItsBuiltFor;
